import React, { useState, useEffect } from 'react';
import { useGameStore } from './state/game-store.js';
import { BattlefieldScene } from './components/3d/BattlefieldScene.js';
import { InGameHUD } from './components/ui/InGameHUD.js';
import { MainMenu } from './components/ui/MainMenu.js';
import { MultiplayerLobby } from './components/ui/MultiplayerLobby.js';
import { GarageArmory } from './components/ui/GarageArmory.js';
import { ArmorAnalysisLab } from './components/ui/ArmorAnalysisLab.js';
import { PauseMenu } from './components/ui/PauseMenu.js';
import { SettingsModal } from './components/ui/SettingsModal.js';
import { AuthModal } from './components/ui/AuthModal.js';
import { MobileControls } from './components/ui/MobileControls.js';


export function App() {
  const gameMode = useGameStore((s) => s.gameMode);
  const checkAuth = useGameStore((s) => s.checkAuth);
  const [showMultiplayerLobby, setShowMultiplayerLobby] = useState(false);
  const [showGarageArmory, setShowGarageArmory] = useState(false);
  const [showArmorLab, setShowArmorLab] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-zinc-950">
      {/* 1. 3D WebGL Canvas (Always mounted for performance and background ambience) */}
      <BattlefieldScene />

      {/* 2. Tactical In-Game HUD (active during combat) */}
      {gameMode !== 'menu' && <InGameHUD />}

      {/* 2.1 Mobile Touch Controls (Joystick & Action Buttons) */}
      <MobileControls />


      {/* 3. Main Menu overlay */}
      {gameMode === 'menu' &&
        !showMultiplayerLobby &&
        !showGarageArmory &&
        !showArmorLab && (
          <MainMenu
            onOpenMultiplayer={() => setShowMultiplayerLobby(true)}
            onOpenGarage={() => setShowGarageArmory(true)}
            onOpenArmorLab={() => setShowArmorLab(true)}
            onOpenSettings={() => setShowSettings(true)}
          />
        )}

      {/* 4. Multiplayer Room Lobby */}
      {showMultiplayerLobby && (
        <MultiplayerLobby onBack={() => setShowMultiplayerLobby(false)} />
      )}

      {/* 4.1 3D Garage & Armory */}
      {showGarageArmory && (
        <GarageArmory onBack={() => setShowGarageArmory(false)} />
      )}

      {/* 4.2 Armor Analysis Lab */}
      {showArmorLab && (
        <ArmorAnalysisLab onBack={() => setShowArmorLab(false)} />
      )}

      {/* 5. In-Game Pause Menu */}
      <PauseMenu onOpenSettings={() => setShowSettings(true)} />

      {/* 6. Settings Modal */}
      <SettingsModal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
      />

      {/* 7. Authentication Modal (Register / Login) */}
      <AuthModal />
    </div>
  );
}

export default App;

